import { poOpenOrder } from '@/utils/shared'

export const ListConfig = (orderBy) => ({
  id: 'open-wo',
  isAutoLoad: false,
  store: {
    get: {
      url: 'RepairExchangeOrderFollowUps/GetAllDynamic',
      selected: [
        'id',
        'reminderDate', 'phasePersonInChargeEmployeeID', 'lastInfo', 'shipped', 'shippedDate', 'quoteReceived', 'quoteReceivedDate',
        'quoteApproved', 'quoteApprovedDate', 'unitShipped', 'unitShippedDate', 'standby', 'standbyDate', 'partSN',
        'part.partNumber as partNumber', 'baxpo', 'orderPhaseID', 'phaseDate',

        'rfq.customerCompany.Name as customerCompanyName', 'rfq.po as po', 'rfq.id as rfqID',
        'rfq.rfqTypeID as rfqTypeID',

        'rfq2.id as rfq2ID',
        'rfq2.estimatedDeliveryDate as estimatedDeliveryDate',
        'rfq2.supplierCompany.name as supplierCompanyName'
      ],
      filters: '(baxpo==null)?(1==2):(baxpo.StartsWith("W"))',
      orderBy: poOpenOrder(orderBy),
      expand: true
    },
    create: {
      url: 'RepairExchangeOrderFollowUps/Create'
    },
    patch: {
      url: (data) => `RepairExchangeOrderFollowUps/Patch/${data.id}`
    },
    delete: {
      url: (data) => `RepairExchangeOrderFollowUps/Delete/${data.id}`
    }
  },
  autoSave: {
    url: (data) => `RepairExchangeOrderFollowUps/Patch/${data.id}`
  },
  header: {
    isVisible: false
  },
  content: {
    isScroll: false
  },
  export: {
    excel: {
      // eslint-disable-next-line no-template-curly-in-string
      name: "${root.L10n('open-wo')}",
      columns: [
        {
          // eslint-disable-next-line no-template-curly-in-string
          title: "${root.L10n('supplier')}",
          field: 'supplierCompanyName',
          width: 25
        },
        {
          // eslint-disable-next-line no-template-curly-in-string
          title: "${root.L10n('baxpo')}",
          field: 'baxpo'
        },
        {
          // eslint-disable-next-line no-template-curly-in-string
          title: "${root.L10n('supplier-contact')}",
          field: 'supplierContactName',
          width: 25
        },
        {
          // eslint-disable-next-line no-template-curly-in-string
          title: "${root.L10n('part-number')}",
          field: 'partNumber',
          width: 20
        },
        {
          // eslint-disable-next-line no-template-curly-in-string
          title: "${root.L10n('part-SN')}",
          field: 'partSN'
        },
        {
          // eslint-disable-next-line no-template-curly-in-string
          title: "${root.L10n('price')}",
          field: 'price'
        },
        {
          // eslint-disable-next-line no-template-curly-in-string
          title: "${root.L10n('currency')}",
          field: 'currencyTitle'
        },
        {
          // eslint-disable-next-line no-template-curly-in-string
          title: "${root.L10n('condition')}",
          field: 'conditionTitle'
        }
      ]
    }
  },
  controls: {
    isVisible: false
  },
  footer: {
    isVisible: true,
    pagination: {
      isVisible: true,
      size: 50,
      sizes: {
        isVisible: true,
        values: [
          { label: 25, value: 25 },
          { label: 50, value: 50 },
          { label: 100, value: 100 }
        ]
      }
    }
  }
})
